import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { AnalyticsMonth } from '../../../domain/models/analytics-period.model';
import { AnalyticsSummaryDto } from '../../dtos/analytics-summary.dto';

@Injectable()
export class AnalyticsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  // `year`/`month` go over as plain integers (month 1-12) rather than a `YYYY-MM` string: the API
  // binds them as two scalars and validates each, so a malformed value is a 400 instead of silently
  // resolving to some default window.
  public getSummary(period: AnalyticsMonth, departmentId?: number): Observable<AnalyticsSummaryDto> {
    const params: Record<string, number> = { year: period.year, month: period.month };
    if (departmentId !== undefined) params['departmentId'] = departmentId;

    return this.http.get<AnalyticsSummaryDto>(`${this.apiUrl}${API_ENDPOINTS.analytics.summary}`, { params });
  }
}
